import React from "react";
import { Box, Typography } from "@material-ui/core";
import { PriceFormat } from "../../../../components/typography/PriceFormat";
import { useSummaryStyles } from "./summary.styles";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/rootReducer";
import { color } from "../../../../app/theme";
import { Loader } from "swyft-react-core";

/**
 * Displays the quote total, a list of payments (if any), and the balance payable.
 * Payments are fetched from /quote/{quoteId}/payments.
 */
export const SummaryPayments: React.FC = () => {
  const classes = useSummaryStyles();

  const { quote, balance, balanceError } = useSelector((state: RootState) => state.quote);

  //   const { data: payments = [], isLoading } = useQuery<Payment[]>(
  //     ["payments", quote?.id],
  //     async () => {
  //       const res = await fetch(`/quote/${quote?.id}/payments`);
  //       if (!res.ok) throw new Error("Failed to fetch payments");
  //       return res.json();
  //     },
  //     { enabled: !!quote?.id }
  //   );

  if (!quote || (!balance && !balanceError)) {
    return <Loader />;
  }

  if (balanceError || (balance && balance.balance < 0)) {
    return (
      <Box className={classes.summaryTotal}>
        <Box className={classes.summaryTotalPayable}>
          <Typography variant="body1">Quote Total</Typography>
          <span>
            <PriceFormat value={quote.price} />
          </span>
        </Box>
      </Box>
    );
  }

  // If balance is less than quote.price, show a payment line for the difference
  const paymentAmount = quote.price - balance!.balance;
  const hasPayment = paymentAmount > 0;

  return (
    <Box className={classes.summaryTotal}>
      <Box className={classes.summaryTotalPayable}>
        <Typography variant="body1">Quote Total</Typography>
        <span>
          <PriceFormat value={quote.price} />
        </span>
      </Box>
      {hasPayment && (
        <Box mt={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="body2" color="textSecondary">
              Payment
            </Typography>
            <span style={{ color: color.orange }}>
              -<PriceFormat value={paymentAmount} />
            </span>
          </Box>
        </Box>
      )}
      <Box className={classes.summaryTotalCost} mt={2}>
        <Typography variant="body1">Balance payable</Typography>
        <span>
          <PriceFormat value={balance!.balance} />
        </span>
      </Box>
    </Box>
  );
};
